import React from 'react';

import { DesignOptionGroup } from 'editor/src/store/variants/types';

import DesignOptionVariationGroup from './DesignOptionVariationGroup';

interface Props {
  selectedDesignOptionValue: string;
  groups: DesignOptionGroup[];
  onDelete?: (key: string) => void;
}

function DesignOptionsVariationGroupList({ selectedDesignOptionValue, groups, onDelete }: Props) {
  return (
    <>
      {groups.map((group) => (
        <DesignOptionVariationGroup
          selectedDesignOptionValue={selectedDesignOptionValue}
          designGroup={group}
          onDelete={onDelete}
          key={`${group.key}-${group.name}`}
        />
      ))}
    </>
  );
}

export default React.memo(DesignOptionsVariationGroupList);
